import React, { useEffect, useState } from 'react'
import { Drawer, Button, Tag, Icon, Input, Tooltip, message } from 'antd';
import { useUpdateEffect } from 'ahooks';
import { commitReMarkPictureInCollTask } from '../../../../../api/inspiration'
import './index.less';

export default (props) => {
  const { editTagsDrawer, onClose, supplementTags, attrTags, classifyTags, setAttrTags, setSupplementTags, setClassifyTags, collId, collName, setCollName, goUpdateTagInfo } = props
  // 新增
  const [classifyTagsInputVisible, setClassifyTagsInputVisible] = useState(false)
  const [attrTagsInputVisible, setAttrTagsInputVisible] = useState(false)
  const [supplementTagsInputVisible, setSupplementTagsInputVisible] = useState(false)
  // 新输入属性tag
  const [inputAttrValue, setinputAttrValue] = useState('')
  // 新输入标签tag
  const [inputSuppValue, setinputSuppValue] = useState('')
  // 新输入分类tag
  const [inputClassifyValue, setinputClassifyValue] = useState('')
  const [inputCollNameValue, setinputCollNameValue] = useState('')
  const getUsername = () => {
    return localStorage.getItem('username');
  };
  useUpdateEffect(() => {
    if (!editTagsDrawer) {
      setinputAttrValue('')
      setinputSuppValue('')
      setinputCollNameValue('')
      setinputClassifyValue('')
    }
  }, [editTagsDrawer])

  const setinputCollNameValueChange = (e) => {
    setinputCollNameValue(e.target.value)
  }
  const handleCollNameInputConfirm = () => {
    if (inputCollNameValue) {
      setCollName(inputCollNameValue)
    }
  }
  // 分类tag
  const handleClassifyInputChange = (e) => {
    setinputClassifyValue(e.target.value)
  }
  const handleClassifyInputConfirm = () => {
    if (inputClassifyValue) {
      setClassifyTags([inputClassifyValue])
      setinputClassifyValue('')
      setClassifyTagsInputVisible(false)
    }
  }
  const handleClassifyClose = () => {
    setClassifyTags([])
  }

  // 属性tag
  const handleAttrInputChange = (e) => {
    setinputAttrValue(e.target.value)
  }
  const handleAttrInputConfirm = () => {
    if (inputAttrValue && attrTags.indexOf(inputAttrValue) === -1) {
      setAttrTags([...attrTags, inputAttrValue])
      setinputAttrValue('')
      setAttrTagsInputVisible(false)
    }
  }
  const handleAttrClose = (removeTag) => {
    const newTagList = attrTags.filter((tag) => tag !== removeTag)
    setAttrTags([...newTagList])
  }
  // 标签tag
  const handleSuppInputChange = (e) => {
    setinputSuppValue(e.target.value)
  }
  const handleSuppInputConfirm = () => {
    if (inputSuppValue && supplementTags.indexOf(inputSuppValue) === -1) {
      setSupplementTags([...supplementTags, inputSuppValue])
      setinputSuppValue('')
      setSupplementTagsInputVisible(false)
    }
  }
  const handleSuppClose = (removeTag) => {
    const newTagList = supplementTags.filter((tag) => tag !== removeTag)
    setSupplementTags([...newTagList])
  }
  // 图集下图片重新打标
  const goReMarking = async () => {
    try {
      const res = await commitReMarkPictureInCollTask(collId, getUsername())
      if (res.error?.code == 0) {
        message.success('操作成功')
      } else {
        message.error(res.error.message)
      }
    } catch (error) { }
  }

  return (
    <>
      <Drawer title="编辑图集标签" placement="right" onClose={onClose} visible={editTagsDrawer} width={320}>
        <p><span style={{ width: 70 }}>图集标题：</span>
          <Input
            type="text"
            style={{ width: 200 }}
            value={inputCollNameValue}
            placeholder={collName}
            onChange={setinputCollNameValueChange}
            onBlur={handleCollNameInputConfirm}
            onPressEnter={handleCollNameInputConfirm}
          />
        </p>
        <p><span style={{ width: 70 }}>分类标签：</span>
          {classifyTags?.map((tag) => {
            const isLongTag = tag.length > 20;
            const tagElem = (
              <Tag key={tag} closable onClose={handleClassifyClose} style={{ marginBottom: 10 }}>
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={tag} key={tag}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })}
          {classifyTagsInputVisible && (
            <Input
              type="text"
              size="small"
              style={{ width: 78 }}
              value={inputClassifyValue}
              onChange={handleClassifyInputChange}
              onBlur={handleClassifyInputConfirm}
              onPressEnter={handleClassifyInputConfirm}
            />
          )}
          {!classifyTagsInputVisible && !classifyTags?.length && (
            <>
              <Tag onClick={() => setClassifyTagsInputVisible(true)} style={{ background: '#fff', borderStyle: 'dashed' }}>
                <Icon type="plus" />添加分类
              </Tag>
            </>
          )}
        </p>
        <p style={{ display: 'flex' }}><span style={{ width: 70 }}>属性标签：</span>
          <div style={{ flex: 1 }}>
            {attrTags?.map((tag) => {
              const isLongTag = tag.length > 20;
              const tagElem = (
                <Tag key={tag} closable onClose={() => handleAttrClose(tag)} style={{ marginBottom: 10 }}>
                  {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                </Tag>
              );
              return isLongTag ? (
                <Tooltip title={tag} key={tag}>
                  {tagElem}
                </Tooltip>
              ) : (
                tagElem
              );
            })}
            {attrTagsInputVisible && (
              <Input
                type="text"
                size="small"
                style={{ width: 78 }}
                value={inputAttrValue}
                onChange={handleAttrInputChange}
                onBlur={handleAttrInputConfirm}
                onPressEnter={handleAttrInputConfirm}
              />
            )}
            {!attrTagsInputVisible && (
              <Tag onClick={() => setAttrTagsInputVisible(true)} style={{ background: '#fff', borderStyle: 'dashed' }}>
                <Icon type="plus" />添加属性
              </Tag>
            )}
          </div>
        </p>
        <p style={{ display: 'flex' }}><span style={{ width: 70 }}>补充标签：</span>
          <div style={{ flex: 1 }}>
            {supplementTags?.map((tag) => {
              const isLongTag = tag.length > 20;
              const tagElem = (
                <Tag key={tag} closable onClose={() => handleSuppClose(tag)} style={{ marginBottom: 10 }}>
                  {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                </Tag>
              );
              return isLongTag ? (
                <Tooltip title={tag} key={tag}>
                  {tagElem}
                </Tooltip>
              ) : (
                tagElem
              );
            })}
            {supplementTagsInputVisible && (
              <Input
                type="text"
                size="small"
                style={{ width: 78 }}
                value={inputSuppValue}
                onChange={handleSuppInputChange}
                onBlur={handleSuppInputConfirm}
                onPressEnter={handleSuppInputConfirm}
              />
            )}
            {!supplementTagsInputVisible && (
              <Tag onClick={() => setSupplementTagsInputVisible(true)} style={{ background: '#fff', borderStyle: 'dashed' }}>
                <Icon type="plus" />添加标签
              </Tag>
            )}
          </div>
        </p>
        <div className='two_button'> <Button onClick={onClose}>取消</Button> <Button type="primary" onClick={goUpdateTagInfo} disabled={!collName}>确定</Button> </div>
        <span className='reMarking' onClick={() => {
          goReMarking()
        }}>→执行图集下的图片重新打标</span>
      </Drawer>
    </>
  )
}
